import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {useForm} from 'react-hook-form'
import {joiResolver} from '@hookform/resolvers/joi'
import {VmoDropdown, VmoDropdownItem, VmoDropdownMenu, VmoMenuItem} from 'vmo-library'
import {FiFolder, FiMoreVertical, FiTrash2} from 'react-icons/fi'
import {
  ADD_COMPANY_SEGMENT,
  DELETE_COMPANY_SEGMENT,
  GET_ALL_COMPANY_SEGMENT,
  GET_COMPANY_SEGMENT,
  UPDATE_COMPANY_SEGMENT,
} from 'actions/types'
import {
  addCompanySegment,
  deleteCompanySegment,
  getAllCompanySegment,
  getCompanySegment,
  updateCompanySegment,
} from 'actions/segment'
import useApiResponse from 'hooks/impure/useApiResponse'
import DeleteModal from 'components/common/DeleteModal'
import {companySegmentStep1Schema, companySegmentStep2Schema} from 'validation/customers/company.schema'
import {FaEdit} from 'react-icons/fa'
import CompanySegmentStep2 from './Company/CompanySegmentStep2'
import SegmentStep1 from './SegmentStep1'

const defaultValues = {
  name: '',
  isStatic: true,
}
const defaultValues1 = {
  ids: [],
  conditions: {},
}

const AddCompanySegment = ({type = 'company', currentStep, setCurrentStep}) => {
  const [deleteId, setDeleteId] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [editId, setEditId] = useState('')
  const [filter, setFilter] = useState({})
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSchema = type => {
    if (type === 'company') {
      return companySegmentStep2Schema
    }
  }

  const {
    handleSubmit,
    formState: {errors},
    control,
    getValues,
    reset,
    watch,
  } = useForm({
    resolver: joiResolver(companySegmentStep1Schema),
    shouldUnregister: false,
    defaultValues,
  })

  const {
    handleSubmit: handleSubmit2,
    formState: {errors: errors2},
    control: control2,
    getValues: getValues2,
    reset: reset2,
    watch: watch2,
    setValue: setValue2,
  } = useForm({
    resolver: joiResolver(handleSchema(type)),
    shouldUnregister: false,
    defaultValues: defaultValues1,
  })

  const {data: segmentCompanyList = []} = useApiResponse({
    label: GET_ALL_COMPANY_SEGMENT,
    storePath: 'segment.segmentCompanyList',
  })

  useApiResponse({
    label: ADD_COMPANY_SEGMENT,
    onSuccess: () => {
      dispatch(getAllCompanySegment())
      setCurrentStep(false)
      reset(defaultValues)
      reset2(defaultValues1)
      setDeleteId('')
      setEditId('')
    },
  })
  useApiResponse({
    label: UPDATE_COMPANY_SEGMENT,
    onSuccess: () => {
      dispatch(getAllCompanySegment())
      setCurrentStep(false)
      reset(defaultValues)
      reset2(defaultValues1)
      setDeleteId('')
      setEditId('')
      setDeleteModal(false)
    },
  })
  useApiResponse({
    label: DELETE_COMPANY_SEGMENT,
    onSuccess: () => {
      dispatch(getAllCompanySegment())
      setCurrentStep(false)
      reset(defaultValues)
      reset2(defaultValues1)
      setDeleteId('')
      setEditId('')
    },
  })

  useApiResponse({
    label: GET_COMPANY_SEGMENT,
    storePath: 'segment.segmentCompanyData',
    onSuccess: segmentCompanyData => {
      reset({
        name: segmentCompanyData.name,
        isStatic: segmentCompanyData.isStatic,
      })
      reset2({
        conditions: segmentCompanyData.conditions,
        ids: segmentCompanyData.ids,
      })
      setFilter(segmentCompanyData.conditions)
    },
  })

  const CreateSegment = () => {
    const payload = {
      ...getValues(),
      ...getValues2(),
    }

    if (editId) {
      dispatch(updateCompanySegment(type, payload, editId))
    } else {
      dispatch(addCompanySegment(type, payload))
    }
  }

  useEffect(() => {
    dispatch(getAllCompanySegment(type))
  }, [dispatch, type])

  useEffect(() => {
    if (currentStep === false) {
      dispatch({type: 'CLEAR_SEGMENT_DATA'})
      setDeleteId('')
      reset(defaultValues)
      reset2(defaultValues1)
    }
  }, [currentStep, dispatch, reset, reset2])

  return (
    <>
      {segmentCompanyList.map(segment => (
        <VmoMenuItem
          key={segment.id}
          className="vmo-seg-item"
          active={window.location.pathname.includes(`/customers/companies/segment/${segment.id}`)}
          onClick={() => {
            navigate(`/customers/companies/segment/${segment.id}`)
          }}
        >
          <FiFolder /> {segment.name}
          <VmoDropdown button icon={<FiMoreVertical />} className="right-dd">
            <VmoDropdownMenu className="m-0" direction="left">
              <VmoDropdownItem
                onClick={() => {
                  setCurrentStep('step1')
                  setEditId(segment.id)
                  dispatch(getCompanySegment(type, segment.id))
                }}
              >
                <FaEdit /> Edit
              </VmoDropdownItem>
              <VmoDropdownItem
                onClick={() => {
                  setDeleteModal(true)
                  setDeleteId(segment.id)
                }}
              >
                <FiTrash2 /> Delete
              </VmoDropdownItem>
            </VmoDropdownMenu>
          </VmoDropdown>
        </VmoMenuItem>
      ))}

      {!(currentStep === false) && (
        <>
          <SegmentStep1
            open={currentStep === 'step1'}
            setOpen={setCurrentStep}
            control={control}
            handleSubmit={handleSubmit}
            errors={errors}
            watch={watch}
            type={type}
          />
          {currentStep === 'company' && (
            <CompanySegmentStep2
              open={currentStep === 'company'}
              setOpen={setCurrentStep}
              control={control2}
              handleSubmit={handleSubmit2}
              errors={errors2}
              CreateSegment={CreateSegment}
              getValues={getValues2}
              watch={watch2}
              step1Values={watch}
              setValue={setValue2}
              reset={reset2}
              filter={filter}
              setFilter={setFilter}
              editId={editId}
              type={type}
            />
          )}
        </>
      )}
      {deleteModal && (
        <DeleteModal
          isModalOpen={deleteModal}
          setIsModalOpen={setDeleteModal}
          onDelete={() => {
            dispatch(deleteCompanySegment(type, deleteId))
          }}
          type={type}
        />
      )}
    </>
  )
}

export default AddCompanySegment
